import React, { createContext, useContext, useState } from 'react';

type NavigationState = {
  lastVisited: string;
  setLastVisited: (path: string) => void;
};

const NavigationContext = createContext<NavigationState | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lastVisited, setLastVisited] = useState<string>('/track');

  return (
    <NavigationContext.Provider value={{ lastVisited, setLastVisited }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error('useNavigation must be used within NavigationProvider');
  return ctx;
}; 